import {
  FieldsEnum,
  FormsEnum,
  RenewalChangedAddressEnum,
} from 'app/shared/enums';
import { zipCodeChange } from 'app/services/businessFunctions/helpers/zipCodeChange';
import { showAddressFieldsForRenewal } from 'app/services/businessFunctions/helpers/showAddressFieldsForRenewal';

const secondCoownerAddressDetails = {
  checkoutCoowners2LegalAddressZipCodeChange(initialRun: boolean) {
    showAddressFieldsForRenewal(
      initialRun,
      RenewalChangedAddressEnum.Coowner2Legal
    );

    zipCodeChange(
      initialRun,
      FieldsEnum.Coowners2LegalAddressZipCode,
      FormsEnum.CheckoutForm
    );
  },
  checkoutCoowners2LegalAddressCityChange(initialRun: boolean) {
    showAddressFieldsForRenewal(
      initialRun,
      RenewalChangedAddressEnum.Coowner2Legal
    );
  },
  checkoutPaymentSuspendedCoowners2LegalAddressZipCodeChange(
    initialRun: boolean
  ) {
    zipCodeChange(
      initialRun,
      FieldsEnum.Coowners2LegalAddressZipCode,
      FormsEnum.CheckoutPaymentAlertForm
    );
  },
};

export default secondCoownerAddressDetails;
